import { Button, Col } from 'antd';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BsThreeDotsVertical } from "react-icons/bs";


const InvCard = ({item}) => {
  const navigate = useNavigate();
  
  const handleToProcess = () => {
    navigate('/inventory/transfers/options/'+encodeURI(JSON.stringify({seo: item.seo, status: 'ready'})));
  }

  const handleWaitingProcess = () => {
    navigate('/inventory/transfers/options/'+encodeURI(JSON.stringify({seo: item.seo, status: 'waiting'})));
  }
  
  return (
    <Col md={{span: 6}} style={{height: '150px'}} className='m-1 border'>
      <div className='bg-white p-3 h-full'>
        <div className='h-1/2 flex justify-between'>
          <div>
            <h2 className='text-[#017075] font-semibold text-lg'><Link to={'/inventory/transfers/options/'+encodeURI(JSON.stringify({seo: item.seo}))} className='hover:text-black'>{item.operation}</Link></h2>
            <span className='text-gray-900'>{item.warehouse}</span>
          </div>
          <span className='hover:cursor-pointer'><BsThreeDotsVertical /></span>
        </div>
        <div className='h-1/2 flex justify-between'>
          <Button size='small' onClick={handleToProcess} type='primary' className='rounded-none font-semibold bg-[#189aa0] hover-btn'>{item.to_process} TO PROCESS</Button>
          <div className='w-1/2'>
            <Button size='small' type='text' onClick={handleWaitingProcess} className='text-[#017075] text-sm'>{item.waiting} Waiting</Button>
          </div>
        </div>
      </div>
    </Col>
  )
}

export default InvCard;